<div class="_flex _flex-col" *ngIf="nameControl">
    <div class="_flex _justify-between _pb-3 _border-b _border-transparency-black-5 _shadow-bottom">
        <div class="_h4">Create {{ "wishlist" | businessName }}</div>
        <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
    </div>

    <mat-dialog-content>
        <fieldset class="_my-16">
            <label class="_text-md">Description for this {{ "wishlist" | businessName }}</label>
            <input 
                class="_input-squared _w-full _mt-1"
                autocomplete="off" 
                [placeholder]="'E.g. Safari tour ' + nextYear"
                [formControl]="nameControl">
        </fieldset>
    </mat-dialog-content>

    <div class="_flex _justify-end">
        <button 
            class="_button-primary"    
            (click)="createWishlist()"
            [disabled]="!nameControl.valid">
                Create
        </button>
    </div>
</div>
